export default __webpack_public_path__ + "static/media/404.62218056.png";